module.exports = __webpack_public_path__ + "static/media/MUDANZASTSS.c7b71c6e.png";